import axiosInstance from "../api/axiosInstance";
import { DISPATCHES } from "../constants/API_URLs";

export interface DispatchData {
  serialNumber: string;
  dispatchDate: Date;
  driverName: string;
  vehicleNumber: string;
  totalParty: number;
  totalPicklist: number;
  totalInvoice: number;
  invoiceAmount: number;
  totalBox: number;
  grNumber: number;
}

export const getDispatch = (id: any): Promise<any> => {
  return axiosInstance.get(`${DISPATCHES}/${id}`);
};

export const getDispatches = (params: any): Promise<any> => {
  return axiosInstance.get(DISPATCHES, { params });
};
